import { axiosPrivate, axiosPublic } from 'app/utils';
import helpers from './helpers';

export default {
  async createUser(data) {
    const response = await axiosPublic.post('/users', data);
    if (response.data.error) helpers.throwError(response.data.error);
    if (!response.data.data[0]) throw new Error('Response malformed');

    return response.data.data[0];
  },

  async updateToken(data) {
    const response = await axiosPrivate.put('/tokens', data);
    if (response.data.error) helpers.throwError(response.data.error);
    if (!response.data.data[0]) throw new Error('Response malformed');

    return true;
  },

  async login(data) {
    const response = await axiosPublic.post('/tokens', data, {
      headers: { 'api-version': '3.6.0' },
    });
    if (response.data.error) helpers.throwError(response.data.error);
    if (!response.data.data[0]) throw new Error('Response malformed');

    return response.data.data[0];
  },
};
